import { ContentNode, ContentNodeType } from "@/app/graphql/codegen";

/**
 * Liefert eine konsistente Dokumentenbezeichnung für die gesamte Anwendung
 */
export const getUnifiedDocumentLabel = (node: ContentNode | null, options?: {
  showType?: boolean,
  truncate?: boolean,
  maxLength?: number,
  showParentPrefix?: boolean
}): string => {
  if (!node) return "";
  
  const { showType = false, truncate = false, maxLength = 36, showParentPrefix = true } = options || {};
  
  // Basisbezeichnung mit konsistenter Priorität ermitteln
  let label = "";
  
  if (node.type === ContentNodeType.DetailedSummary || node.type === ContentNodeType.GraphSummary) {
    // For summary nodes, use consistent "Zusammenfassung: <docRef>" format
    const docRef = node.associatedOfficialDocument?.reference || node.metadata?.reference || "Dokument";
    label = `Zusammenfassung: ${docRef}`;
  } else if (node.type === ContentNodeType.SubSection) {
    // Für Unterabschnitte priorisieren wir strukturierte Darstellung
    const sectionNumber = node.metadata?.sectionNumber || "";
    const title = node.metadata?.title || node.name || "";
    const startPage = node.metadata?.startPage;
    const endPage = node.metadata?.endPage;
    
    // If we have page range metadata, use it for structured display
    if (startPage && endPage) {
      // Display format: "Pages X-Y: Title"
      label = `Pages ${startPage}-${endPage}`;
      // Only append title if it's different from the page range and non-empty
      if (title && !title.toLowerCase().includes('page')) {
        label += `: ${title}`;
      }
    } else if (sectionNumber) {
      // Wenn eine Abschnittsnummer vorhanden ist, verwenden wir sie ohne Umformatierung
      label = sectionNumber;
      if (title && title !== sectionNumber) label += ` - ${title}`;
    } else {
      // Fallback hierarchy: hoverTitle → name → metadata.title → subdirectory
      label = node.hoverTitle || 
              node.name || 
              node.metadata?.title || 
              node.metadata?.subdirectory || 
              "";
    }
    
    // Wenn gewünscht und verfügbar, füge den Namen des übergeordneten Dokuments als Präfix hinzu
    if (showParentPrefix && node.associatedOfficialDocument?.reference) {
      label = `${node.associatedOfficialDocument.reference} | ${label}`;
    }
  } else {
    // Für Hauptdokumente verwenden wir die Referenz als primären Bezeichner
    // Falls vorhanden, bevorzugen wir hoverTitle über andere Metadaten
    label = node.associatedOfficialDocument?.reference || node.hoverTitle || node.metadata?.subdirectory || "";
  }
  
  // Bei Bedarf Typ-Suffix hinzufügen
  // if (showType) {
  //   if (node.type === ContentNodeType.Summary || 
  //       node.type === ContentNodeType.DetailedSummary) {
  //     label += " (Graph-Doc)";
  //   }
  // }
  
  // Bei Bedarf kürzen
  if (truncate && label.length > maxLength) {
    return label.substring(0, maxLength) + "…";
  }
  
  return label;
} 